import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { TransmissionParent } from '@app/models/carnet-liaison';
import { CarnetHeureFormatPipe } from '../../carnet-liaison.pipe';

@Component({
  selector: 'app-carnet-transmission-parent',
  templateUrl: './carnet-transmission-parent.component.html',
  styleUrl: './carnet-transmission-parent.component.scss',
  standalone: true,
  imports: [SharedModule, CarnetHeureFormatPipe],
})
export class CarnetTransmissionParentComponent {
  data = input.required<TransmissionParent>();

  getVenuAvecLabels(): string[] {
    const c = this.data().ongletTransmission?.checkbox_venuAvec;
    if (!c) return [];
    const labels: string[] = [];
    if (c.doudou) labels.push('Doudou');
    if (c.tetine) labels.push('Tétine');
    if (c.traitementMedicament) labels.push('Traitement / Médicament');
    return labels;
  }

  getSommeilQualiteLabel(): string | null {
    const r = this.data().ongletTransmission?.radio_qualiteSommeil;
    if (!r) return null;
    if (r.bienDormi) return 'Bien dormi';
    if (r.sommeilAgite) return 'Sommeil agité';
    return null;
  }
}
